import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  DoppiaMaterialitaService,
  Opportunita,
  Rischio,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { ScritturaImpatto } from 'src/app/services/impatto/impatto.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-crea-iro',
  standalone: false,

  templateUrl: './dialog-crea-iro.component.html',
  styleUrl: './dialog-crea-iro.component.scss',
})
export class DialogCreaIroComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  private _titolo: string = '';

  get titolo() {
    return this._titolo;
  }

  public arrayOrizzontiTemporali: ScritturaImpatto[] = [];

  public arrayCatene: ScritturaImpatto[] = [];

  public formElementoIro = new FormGroup({
    id: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),

    descrizione: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
    /* valoreAttribuito: new FormControl<number>(0, {
      nonNullable: true,
      validators: [],
    }), */
    creatoDaContesto: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    selected: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),

    idAmbito: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
    idTematica: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
    idTema: new FormControl<string | undefined>('', {
      nonNullable: true,
      validators: [],
    }),
    orizzontiTemporali: new FormControl<string[]>([], {
      nonNullable: true,
      validators: [],
    }),
    fonte: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    catene: new FormControl<string[]>([], {
      nonNullable: true,
      validators: [],
    }),
    validato: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
  });

  constructor(
    private doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly utilityService: UtilityService,
    public readonly dialogRef: MatDialogRef<DialogCreaIroComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipoIro: 'rischio' | 'opportunita';
      elemento: Rischio | Opportunita;
      idContest: string;
      idAmbito: string;
      idTematica: string;
      idTema?: string; // Solo per impatti doppia materialità
      contesto: string;
      titoloESRS?: { etichetta: string; titolo: string };
    },
  ) {
    if (data.tipoIro === 'rischio') {
      this._titolo = 'Rischio';
    } else if (data.tipoIro === 'opportunita') {
      this._titolo = 'Opportunità';
    }
  }

  ngAfterViewInit(): void {
    this.datiIniziali();
    this.cdRef.detectChanges();
  }

  public datiIniziali() {
    this.doppiaMaterialitaService.getImpattoOrizTemp().subscribe((impattoOrizTemp) => {
      this.arrayOrizzontiTemporali = impattoOrizTemp;
    });

    this.doppiaMaterialitaService.getCatena().subscribe((valCatena) => {
      this.arrayCatene = valCatena;
    });

    this.formElementoIro.get('idAmbito')?.setValue(this.data.idAmbito);

    this.formElementoIro.get('idTematica')?.setValue(this.data.idTematica);

    this.formElementoIro.get('idTema')?.setValue(this.data.idTema);

    if (this.data.elemento) {
      Object.keys(this.data.elemento).forEach((value, index, array) => {
        this.formElementoIro.get(value)?.setValue((this.data.elemento as any)[value]);
      });
    }
  }

  public salva() {
    if (!this.data.idAmbito) {
      this.mostraMessaggio('Attenzione', 'Ambito non trovato o non riconosciuto');
      return;
    } else if (!this.data.idTematica) {
      this.mostraMessaggio('Attenzione', 'Tematica non trovata o non riconosciuta');
      return;
    }

    if (this.formElementoIro.valid) {
      if (!this.formElementoIro.get('id')?.value) {
        this.formElementoIro.get('creatoDaContesto')?.setValue(true);
      }

      let serviceCall;

      if (this.data.tipoIro === 'rischio') {
        serviceCall = this.doppiaMaterialitaService.putRischiEffimeri(
          this.data.idContest,
          this.formElementoIro.getRawValue(),
        );
      } else if (this.data.tipoIro === 'opportunita') {
        serviceCall = this.doppiaMaterialitaService.putOpportunitaEffimeri(
          this.data.idContest,
          this.formElementoIro.getRawValue(),
        );
      }

      if (serviceCall) {
        this.spinnerOver.show();
        serviceCall.pipe(finalize(() => this.spinnerOver.hide())).subscribe({
          next: (result: any) => {
            this.mostraMessaggioSnackbar('Salvataggio effettuato');
            this.dialogRef.close(result);
          },
          error: (err: any) => {
            console.error('Errore durante il salvataggio ' + this.data.tipoIro + ' : ', err);
            this.mostraMessaggio(
              'Attenzione',
              err?.error?.message || "Errore nel salvataggio dell'elemento",
            );
          },
        });
      }
    } else {
      Object.values(this.formElementoIro.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    return null;
  }

  private mostraMessaggio(titolo: string, descrizione: string) {
    this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      bottoni: [{ nome_btn: 'Chiudi' }],
    });
  }

  private mostraMessaggioSnackbar(messaggio: string) {
    this.utilityService.openSnackBar(messaggio, '', {
      duration: 2000,
      panelClass: ['success-snackbar'],
    });
  }
}
